export var TaxRateType;
(function (TaxRateType) {
    TaxRateType[TaxRateType["PERCENTAGE"] = 1] = "PERCENTAGE";
    TaxRateType[TaxRateType["FLAT"] = 2] = "FLAT";
})(TaxRateType || (TaxRateType = {}));
//# sourceMappingURL=tax-rate-type.js.map